import dayjs from 'dayjs';
import React from 'react';

// hooks
import { useAdventures } from '../hooks/useAdventures';
import { useAlgo } from '../hooks/useAlgo';
import AdventurePreview from './AdventurePreview';
import ConnectWalletMessage from './ConnectWalletMessage';
import Spinner from './Spinner';
import Link from 'next/link';

function TheAdventuresPage() {
  const { address } = useAlgo();
  const { adventures, adventuresLoading } = useAdventures();

  const sortedAdventures = adventures.sort((a, b) => {
    // if has entry property show it first in the list
    // adventures with an endDate in the past should be last
    // if entry is not active, show it last
    if (a.active && !b.active) {
      return -1;
    }
    if (!a.active && b.active) {
      return 1;
    }
    if (a.entry && !b.entry) {
      return -1;
    }
    if (!a.entry && b.entry) {
      return 1;
    }
    // put those with no endDate at bottom
    if (!a.endDate && b.endDate) {
      return 1;
    }
    if (a.endDate && !b.endDate) {
      return -1;
    }

    if (a.endDate && b.endDate) {
      return dayjs(a.endDate).diff(dayjs(b.endDate));
    }

    return 0;
  });

  if (!address) {
    return (
      <div className='flex justify-center mt-20'>
        <ConnectWalletMessage />
      </div>
    );
  }

  if (adventuresLoading) {
    return (
      <div className='flex justify-center mt-20'>
        <Spinner dimensionClasses='w-8 h-8' />
      </div>
    );
  }

  return (
    <div className='mt-20'>
      {/* Shitty Jobs Banner */}
      <div className='mb-8 bg-green-600 rounded-lg p-6 shadow-lg'>
        <div className='flex flex-col md:flex-row items-center justify-between gap-4'>
          <div className='flex-1'>
            <h2 className='text-2xl font-bold text-white mb-2'>Check out Shitty Jobs!</h2>
            <p className='text-white/90'>
              Shitty Adventures are being sunsetted. Experience the new AI-powered Shitty Jobs for customized tasks and even better rewards!
            </p>
          </div>
          <Link href='/jobs'>
            <a className='bg-white text-green-600 font-bold px-6 py-3 rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap'>
              Go to Jobs →
            </a>
          </Link>
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        {sortedAdventures.map((adventure, index) => (
          <AdventurePreview adventure={adventure} key={adventure.id} index={index} />
        ))}
      </div>
    </div>
  );
}

export default TheAdventuresPage;
